import React from 'react';
import bgImage from '../../assets/home/bg-4.jpg';

const STEPS = [
  {
    step: '01',
    title: 'Search',
    description: 'Search for any Pokemon card, for example: Charizard VMAX.',
  },
  {
    step: '02',
    title: 'Compare',
    description: 'See eBay, TCGplayer, and Canadian shop listings side by side.',
  },
  {
    step: '03',
    title: 'Buy',
    description: 'Sort by price, condition, or seller and buy where the value is best.',
  },
  {
    step: 'Bonus',
    title: 'Track',
    description: 'Save cards to your collection and monitor value over time.',
  },
];

export default function HowItWorksSection() {
  return (
    <section
      style={{ backgroundImage: `url(${bgImage})` }}
      className="relative overflow-hidden border-y border-border-base bg-cover bg-center bg-no-repeat bg-fixed py-24"
    >
      <div className="absolute inset-0 z-0 bg-black/80 backdrop-blur-[8px]" />
      <div className="relative z-10 mx-auto max-w-7xl px-6">
        <div className="mb-20 text-center">
          <h2 className="mb-6 font-landing-display text-4xl font-bold md:text-5xl">How Does It Work?</h2>
          <p className="mx-auto max-w-2xl text-xl text-text-secondary">
            Find your chase card in seconds with a cleaner buying workflow.
          </p>
        </div>

        <div className="relative grid gap-8 md:grid-cols-4">
          <div className="absolute left-[10%] right-[10%] top-12 z-0 hidden h-[2px] bg-border-base md:block">
            <div className="h-full w-full bg-gradient-to-r from-brand-primary to-brand-hi" />
          </div>

          {STEPS.map((item) => (
            <div key={item.title} className="relative z-10 flex flex-col items-center text-center">
              <div className="relative mb-6 flex h-24 w-24 items-center justify-center rounded-full border-4 border-bg-surface bg-bg-card shadow-xl">
                <div className="absolute inset-0 rounded-full border border-border-hi" />
                <span className={`font-landing-display font-bold text-brand-hi ${item.step === 'Bonus' ? 'text-lg' : 'text-2xl'}`}>
                  {item.step}
                </span>
              </div>
              <h4 className="mb-3 text-xl font-bold text-text-primary">{item.title}</h4>
              <p className="text-text-secondary">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
